"use client";

import React from "react";
import styles from "../css/mainMemberProfilePopup.module.css";
import { usePopup } from "../context/PopupContext";

const MainMemberProfilePopup = ({ onClose, overlay = false, data }) => {
  const { openPopup } = usePopup();

  const main = data?.main || {};
  const mm = data?.mainmember || {};
  const bens = Array.isArray(data?.beneficiaries) ? data.beneficiaries : [];
  const profile = data?.profile || {};

  const homeParts = String(main.homeaddress || "")
    .split(",")
    .map((s) => s.trim());
  const deliveryRaw = main.deliveryaddress;
  let delivery = { street: "", suburb: "", city: "", postal: "" };
  if (deliveryRaw && typeof deliveryRaw === "object" && !Array.isArray(deliveryRaw)) {
    const addr = deliveryRaw["Delivery Address 1"] || {};
    delivery = {
      street: addr.street || "",
      suburb: addr.suburb || "",
      city: addr.city || "",
      postal: addr.postalCode || addr.postal || "",
    };
  } else if (deliveryRaw) {
    const parts = String(deliveryRaw)
      .split(",")
      .map((s) => s.trim());
    delivery = {
      street: parts[0] || "",
      suburb: parts[1] || "",
      city: parts[2] || "",
      postal: parts[3] || "",
    };
  }

  const chronic = Array.isArray(main.chronicconditions)
    ? main.chronicconditions.join(", ")
    : main.chronicconditions || "";
  const allergies = Array.isArray(main.allergies)
    ? main.allergies.join(", ")
    : main.allergies || "";

  const handleNext = () => {
    openPopup("mainMemberMedicalAid", { mergedProfile: data });
  };

  const content = (
    <div className={styles.popup}>
        <div className={styles.header}>
          <h2>Main Member Profile Number: {profile.profilenumber || ""}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.content}>
          <div className={styles.section}>
            <label>Surname</label>
            <input type="text" value={main.surname || ""} readOnly />
            <label>Initial</label>
            <input type="text" value={(main.firstname || "").slice(0, 1).toUpperCase()} readOnly />
          </div>
          <div className={styles.section}>
            <label>First Name(s)</label>
            <input type="text" value={main.firstname || ""} readOnly />
            <label>Title</label>
            <select value={main.title || ""} disabled>
              <option value="Mrs">Mrs</option>
              <option value="Mr">Mr</option>
              <option value="Dr">Dr</option>
            </select>
          </div>
          <div className={styles.section}>
            <label>ID Number</label>
            <input type="text" value={main.idnumber || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Sex</label>
            <select value={main.sex || ""} disabled>
              <option value="F">F</option>
              <option value="M">M</option>
            </select>
            <label>Age</label>
            <input type="text" value={main.age ?? ""} readOnly />
            <label>Weight (kg)</label>
            <input type="text" value={main.weightinkg ?? ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Postal Address</label>
            <input type="text" value={homeParts[0] || ""} readOnly />
            <input type="text" value={homeParts[1] || ""} readOnly />
            <input type="text" value={homeParts[2] || ""} readOnly />
            <input type="text" value={homeParts[3] || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Delivery Address</label>
            <input type="text" value={delivery.street || ""} readOnly />
            <input type="text" value={delivery.suburb || ""} readOnly />
            <input type="text" value={delivery.city || ""} readOnly />
            <input type="text" value={delivery.postal || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Account Number</label>
            <input type="text" value={mm.accountnumber || ""} readOnly />
            <label>Email Address</label>
            <input type="text" value={main.email || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Home/Cell Number</label>
            <input type="text" value={main.contactnumber || ""} readOnly />
            <label>Employer (optional)</label>
            <input type="text" value={mm.employer || ""} readOnly />
          </div>
          <div className={styles.section}>
            <label>Chronic Conditions</label>
            <input type="text" value={chronic || "N/A"} readOnly />
            <label>Allergies</label>
            <input type="text" value={allergies || "N/A"} readOnly />
          </div>
          <div className={styles.section}>
            <label>Beneficiaries</label>
            <input type="text" value={bens.length} readOnly />
          </div>
        </div>
        <button className={styles.nextButton} onClick={handleNext}>
          Next
        </button>
      </div>
  );

  if (overlay) {
    return <div className={styles.overlay}>{content}</div>;
  }
  return content;
};

export default MainMemberProfilePopup;
